// First, tell the browser JS is working:
// Replace no-js with js in html
(function (H) {
  H.className = H.className.replace(/\bno-js\b/, "js");

  if ("ontouchstart" in H) {
    H.className = H.className.replace(/\bno-touch\b/, "touch");
  }
})(document.documentElement);

// Fetch and promise polyfills, it's
// a hassle to try and avoid these for chrome,
// we need them for IE11:
import loadjs from "loadjs";
import onClick from "@/js/libs/onClick";

// expose loadjs to the global space
window.loadjs = loadjs;

let APP = window.APP || {};

// Create media query constructor from our tailwind config
import mediaQueries from "1dr-utils/libs/media-queries";
import breakpoints from "@/js/breakpoints";
APP.media = new mediaQueries(breakpoints.rulesets);

let errorModal;
let errorContent;
let dismissCallback = false;

const getErrorModal = function (cb) {
  const f = () => {
    if (!errorModal) {
      errorModal = document.getElementById("errors-modal");
      errorContent = document.getElementById("block-modal");
    }

    if (typeof cb === "function") {
      cb(errorModal);
    }
  };

  // execute immediately if dom has already loaded
  if (
    document.readyState === "complete" ||
    document.readyState === "loaded" ||
    document.readyState === "interactive"
  ) {
    f();
  } else {
    document.addEventListener("DOMContentLoaded", f);
  }
};

onClick("#dismiss-errors", () => {
  // Hide.
  getErrorModal(() => {
    errorModal.setAttribute("aria-hidden", "true");
    if (typeof dismissCallback === "function") {
      dismissCallback();
      dismissCallback = false;
    }
  });
});

APP.showModal = function (message, _dismissCallback) {
  dismissCallback = _dismissCallback;

  getErrorModal(() => {
    errorContent.innerHTML = message;
    errorModal.setAttribute("aria-hidden", "false");
  });
};
